import { requestApi } from '../util/network'

export const editAccountPhone =
(password, mobile) =>
  requestApi(
    '/o2o_fuwu_manage_account/edit_account_phone',
    'POST',
    {
      password: password,
      mobile: mobile
    },
    'fuwu'
  )

export const editAccountPassword =
(password1, password2, verifyCode) =>
  requestApi(
    '/o2o_fuwu_manage_account/edit_account_password',
    'POST',
    {
      password1: password1,
      password2: password2,

      verify_code: verifyCode
    },
    'fuwu'
  )

